
  import { Component, Prop, Watch } from 'vue-property-decorator';
  import Vue from 'vue';
  import { Pie } from 'vue-chartjs'
  import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale
    } from 'chart.js'

  import Chart from 'chart.js/auto';
  import Context from 'chart.js/auto';
  import { IPieDatasetResource } from '@/types/resource.types';
  ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)
  
  @Component({
      name: 'LastGenerationCategoryPie',
      components: {
        Pie,
        ChartJS
      }
  })
  
  
  export default class LastGenerationCategoryPie extends Vue {

    /* Props
    ============================================*/
      @Prop({type: Object, required: true})
      readonly lastGenerationCategoryDataset: IPieDatasetResource;
      
    
    randomIterator: number = 0;
    chart: Chart | null;
    chartOpt: Object = {
          responsive: true,
          maintainAspectRatio: false,
            tooltips: {
                displayColors:false
            },
            plugins: {
                legend: {
                    display: false,
                },
                tooltips:{
                    callbacks:{
                        label:(value:number, ctx:Context) => {
                            let sum = 0;
                            let dataArr = ctx.data.datasets[0].data;
                            dataArr.map(data => {
                                sum += Number(data);
                            });
                            let percentage = (value*100 / sum).toFixed(2)+"%";
                            return percentage;
                        }
                    }
                }
            }
        };
    /* Data
    ============================================*/
  myStyles: object = {
        height: '100%',
        width: '100%',
        position: 'relative'
      };
  
    /* Computed
    ============================================*/
    get menuCollapsed(){
      return this.$store?.state?.menuIsCollapsed;
    }
    get chartOptions() {
        return {
          responsive: true,
          maintainAspectRatio: false
        };
    }
    chartPlugins() {
        return {
            legend: {
                display: false,
                toggle: false
            }       
        };
    }
    color(format : string){
        switch(format){
            case "Total":
                return "#001b78";
            case "jpg":
                return "#00b159";
            case "3gp":
                return "#d11141";
            case "asf":
                return "#00aedb";
            case "avi":
                return "#f37735";
            case "m4a":
                return "#ffc425";
            case "m4v":
                return "#9467bd";
            case "mov":
                return "#1f77b4";
            case "mp4":
                return "#7f7f7f";
            case "mpg":
                return "#2ca02c";
            case "heic":
                return "#ff69b4";
            case "png":
                return "#17becf";
        }

        return this.getRandomColor();
    }

    getRandomColor(){
        let colors = [
            "#e377c2",
            "#7f7f7f",
            "#bcbd22",
            "#17becf",
            "#ff7f0e",
            "#6a3d9a",
            "#b15928",
            "#393b79",
            "#5254a3",
            "#637939",
        ];
        if(this.randomIterator > colors.length) return "#ffffff";
        return colors[this.randomIterator];
    }
    get chartData(){
        if(this.lastGenerationCategoryDataset){
            return {
                labels: this.lastGenerationCategoryDataset.labels,
                datasets: [{
                    data: this.lastGenerationCategoryDataset.data,
                    backgroundColor: ["#00b159","#d11141", "#00aedb", "#f37735", "#ffc425", "#9467bd", "#1f77b4", "#7f7f7f", "#2ca02c"]
                }]
            }
        }
        return {labels:[], datasets:[]};
    }
    
  }
  
  
  